/**
 * PROTECTED FILE — DO NOT MODIFY WITHOUT PERMISSION
 *
 * Last verified working: 2026-01-03
 *
 * This file controls: React root initialization
 * Changes here have historically broken core game function.
 *
 * Before modifying:
 * 1. Get explicit approval from Zach
 * 2. Create a checkpoint commit
 * 3. Test full baseline after ANY change
 */

import React from 'react'
import ReactDOM from 'react-dom/client'
import App from '@/App.jsx'
import ErrorBoundary from '@/components/ErrorBoundary.jsx'
import '@/index.css'
import '@/i18n.js' // Internationalization - must load before App

ReactDOM.createRoot(document.getElementById('root')).render(
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
) 